import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8be5ae62"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start" }, "Perfil", -1))
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-12 my-0 mb-4 gap-0" }
const _hoisted_3 = { class: "flex gap-4 text-start col-span-9" }
const _hoisted_4 = { class: "w-full h-full rounded-full bg-primary flex items-center justify-center" }
const _hoisted_5 = { class: "text-white font-bold" }
const _hoisted_6 = { class: "overflow-clip" }
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4 my-2" }
const _hoisted_10 = { class: "relative flex w-full" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "relative flex w-full" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "divide-y divide-solid text-left" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:col-span-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Data:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "00/00/00")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:col-span-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "horário:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "07:00 - 13:00")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:col-span-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Escala:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Escala XPTO")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:col-span-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Unidade:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Hospital XPTO")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:col-span-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Especialidade:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Cardiologia Emergência")
], -1))
const _hoisted_20 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "ml-auto w-full sm:max-w-[160px]" }
const _hoisted_22 = { class: "flex justify-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base font-normal" }, [
  /*#__PURE__*/_createTextVNode("O perfil foi desvinculado"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("com sucesso!")
], -1))

import { ref, toRefs, computed } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import SuccessIcon from '@/assets/icons/success.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import CalendarIcon from '@/assets/icons/calendar.vue'
import { resolveAvatarSrc } from '@/utils/avatar'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DutyModal',
  props: {
    modalStateProp: { type: Boolean },
    doctor: {}
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props;



const resolvedPhoto = computed(() => resolveAvatarSrc(props.doctor.photo))

const range = ref<{ end: string | Date; start: string | Date }>({
  start: '',
  end: ''
})



const addDays = (initialDate: string, days: number): Date => {
  const _date = new Date(initialDate)
  _date.setDate(_date.getDate() + days)
  return _date
}

const actualWeek = () => {
  range.value = {
    start: new Date(),
    end: addDays(new Date().toString(), 7)
  }
}

const { modalStateProp } = toRefs(props)

const showModalDeleteSuccess = ref(false)

const close = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      onClose: close,
      modalActive: _unref(modalStateProp)
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(FilledButton, {
            onClick: actualWeek,
            text: "Ver semana atual",
            width: "100%"
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ProtectedAvatar, {
              src: resolvedPhoto.value,
              size: 64
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.doctor.name?.substring(0, 2).toUpperCase()), 1)
                ])
              ]),
              _: 1
            }, 8, ["src"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", {
                class: "font-bold truncate",
                title: _ctx.doctor.name
              }, _toDisplayString(_ctx.doctor.name), 9, _hoisted_7),
              _createElementVNode("p", {
                class: "truncate",
                title: _ctx.doctor.email
              }, _toDisplayString(_ctx.doctor.email), 9, _hoisted_8),
              _createElementVNode("p", null, _toDisplayString(_ctx.doctor.phone), 1)
            ])
          ])
        ]),
        _createVNode(_component_v_date_picker, {
          class: "w-full",
          modelValue: range.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event)),
          "is-range": ""
        }, {
          default: _withCtx(({ inputValue, inputEvents }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("input", _mergeProps({
                  width: "100%",
                  value: inputValue.start
                }, _toHandlers(inputEvents.start, true), {
                  placeholder: "Data inicial*",
                  class: "input-data"
                }), null, 16, _hoisted_11),
                _createVNode(CalendarIcon, {
                  width: 25,
                  height: 25,
                  class: "absolute top-3 right-2 pointer-events-none"
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("input", _mergeProps({
                  width: "100%",
                  value: inputValue.end
                }, _toHandlers(inputEvents.end, true), {
                  class: "input-data",
                  placeholder: "Data final*"
                }), null, 16, _hoisted_13),
                _createVNode(CalendarIcon, {
                  width: 25,
                  height: 25,
                  class: "absolute top-3 right-2 pointer-events-none"
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
            return _createElementVNode("div", {
              class: "grid grid-cols-3 md:grid-cols-10 gap-4 my-0 py-4",
              key: i
            }, _hoisted_20)
          }), 64))
        ])
      ]),
      _: 1
    }, 8, ["modalActive"]),
    _createVNode(ModalVue, {
      onClose: _cache[1] || (_cache[1] = 
      () => {
        showModalDeleteSuccess.value = false
        close()
      }
    ),
      modalActive: showModalDeleteSuccess.value
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(SuccessIcon)
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_23
      ]),
      _: 1
    }, 8, ["modalActive"])
  ], 64))
}
}

})